import { earningsHeadlineLevels } from '../constants'

export const earningsHeadlineCopies = {
  [earningsHeadlineLevels.operating]: {
    subtitle: 'Lo que te queda de tus ventas después del coste de producto, envío, aduanas y devoluciones.',
    sublabel: 'de cada venta que te quedas · <bold>{{amount}}</bold> en total',
  },
  [earningsHeadlineLevels.product]: {
    subtitle:
      'Lo que te queda de tus ventas después del coste de producto. El envío y las aduanas no se incluyen en este periodo.',
    sublabel: 'después del coste de producto · <bold>{{amount}}</bold>',
  },
}

export const netSalesFractionDigits = 2

export const earningsWarningScenarios = {
  missingLogisticsOrCustoms: 'missingLogisticsOrCustoms',
  missingCogs: 'missingCogs',
  missingAllCosts: 'missingAllCosts',
}

export const marginCostTypes = {
  refunds: 'refunds',
  logistics: 'logistics',
  customs: 'customs',
}

export const maxTopMarginCosts = 2

export const earningsWarningCopies = {
  [earningsWarningScenarios.missingLogisticsOrCustoms]:
    'Aún no están tus costes de logística y aduanas, así que esto muestra solo tu margen de producto.',
  [earningsWarningScenarios.missingCogs]:
    'A algunos productos les falta el coste, así que quedan fuera. Súbelo en Inventario para completar tu margen.',
  [earningsWarningScenarios.missingAllCosts]: 'Aún faltan algunos costes, así que este margen es parcial.',
}

export const marginCostLabels = {
  [marginCostTypes.refunds]: 'Reembolsos',
  [marginCostTypes.logistics]: 'Logística',
  [marginCostTypes.customs]: 'Aduanas',
}

export const marginInsightCopies = {
  1: 'Después del coste de producto, tu mayor coste sobre ventas es <bold>{{cost1}}</bold> ({{percentage1}}). Mira el detalle en Markets, Products y Logistics.',
  2: 'Después del coste de producto, tus mayores costes sobre ventas son <bold>{{cost1}}</bold> ({{percentage1}}) y <bold>{{cost2}}</bold> ({{percentage2}}). Mira el detalle en Markets, Products y Logistics.',
}
